import { type KeyboardEvent } from 'react'
import { AccountRecord } from '../../api/client'
import { getAccountDisplayName } from '../../util/account-utils'
import CrossProfileEngageAccountRow from './CrossProfileEngageAccountRow'

type Props = {
    accounts: AccountRecord[]
    currentAccount: AccountRecord
    likedAccount?: AccountRecord
    selectedAccountId?: number
    loading: boolean
    onAccountClick: (account: AccountRecord, disabled: boolean) => void
    onAccountKeyDown: (
        event: KeyboardEvent<HTMLDivElement>,
        account: AccountRecord,
        disabled: boolean
    ) => void
}

function UnlikeBadge() {
    return (
        <span className="inline-flex items-center gap-1 rounded-full bg-red-50 px-2 py-0.5 text-xs font-medium text-red-600">
            Unlike
        </span>
    )
}

export default function CrossProfileEngageUnlikeView(props: Props) {
    const {
        currentAccount,
        likedAccount,
        selectedAccountId,
        loading,
        onAccountClick,
        onAccountKeyDown
    } = props

    const likedMessage = likedAccount
        ? `This comment is liked as ${getAccountDisplayName(likedAccount)}.`
        : 'This comment is liked.'

    if (loading) {
        return (
            <div className="space-y-4 text-gray-700">
                <div className="py-6 text-center text-sm text-gray-500">
                    Loading available profiles…
                </div>
            </div>
        )
    }

    return (
        <div className="space-y-4 text-gray-700">
            <div className="space-y-1">
                <p className="text-sm font-semibold text-gray-950">Unlike as</p>
                <p className="text-xs text-gray-500">
                    {likedMessage} You can only unlike from here.
                </p>
                <p className="text-xs text-gray-500">Click the profile below to remove the like.</p>
            </div>

            {likedAccount ? (
                <ul className="flex max-h-64 flex-col gap-2 overflow-y-auto pr-1">
                    {/* {displayAccounts.map((account) => ( */}
                    <CrossProfileEngageAccountRow
                        key={likedAccount.id}
                        account={likedAccount}
                        currentAccountId={currentAccount.id}
                        isSelected={selectedAccountId === likedAccount.id}
                        isHighlighted={likedAccount.id === likedAccount?.id}
                        rightContent={<UnlikeBadge />}
                        onAccountClick={onAccountClick}
                        onAccountKeyDown={onAccountKeyDown}
                    />
                    {/* ))} */}
                </ul>
            ) : (
                <p className="rounded-md bg-gray-100 px-3 py-2 text-xs text-gray-600">
                    We couldn’t find the profile associated with this like. Refresh and try again.
                </p>
            )}
            {/* )} */}
        </div>
    )
}
